import { render, staticRenderFns } from "./ReadingTask4.vue?vue&type=template&id=8f84a55a&scoped=true&"
import script from "./ReadingTask4.vue?vue&type=script&lang=ts&"
export * from "./ReadingTask4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f84a55a",
  null
  
)

export default component.exports